export const FALLBACK_LANGUAGE = 'en';
